import { defaultApiState } from "@/store/general.types";
import { AccountState } from "./account.types";

export const accountState: AccountState = {
    getAccount: defaultApiState,
    getParticipantAuthority: defaultApiState
}


